(function($) {
  $(document).ready(function() {
    var $win = $(window),
        $body = $('body'),
        $main = $('.main');


    $("#ae-cform-input-reg-email-1").attr("placeholder", "Email");
    $('#main-nav .menu-item a').wrapInner('<span class="menu-item-text"></span>');

    if ($body.hasClass('home')) {

      $('.nav-tour a').on('click', function(event){
        scrollDownNav('.section.tour')
      });
      $('.nav-videos a').on('click', function(event){
        scrollDownNav('.section.videos')
      });
      $('.nav-music a').on('click', function(event){
        scrollDownNav('.section.music')
      });
      $('.nav-store a').on('click', function(event){
        scrollDownNav('.section.shop')
      });
      $('.nav-signup a').on('click', function(event){
        scrollDownNav('.section.subscribe')
      });
    }

    function scrollDownNav(target) {
      event.preventDefault();

      if (screen.width >= 1024) {
        $('html,body').animate({ scrollTop: $(target).offset().top }, 'slow');
      } else {
        $('html,body').animate({ scrollTop: $(target).offset().top }, 'slow');
        $('.js-off-canvas-overlay').trigger('click');
      }
    }
  });
})(jQuery);